import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectListContainer from './ProjectList';
import BasePage from './BasePage';
import { isMobile } from '../../tools/mobileCheck';
import { CSSTransitionGroup } from 'react-transition-group';
import HeaderButtons from './HeaderButtons';

class LoadedContent extends Component {
  render() {
    const { projectSelected, noBack, noMenu } = this.props;

    const backgroundImage = projectSelected
      ? { backgroundImage: `url(${projectSelected.background})` }
      : {};

    return (
      <div id="loaded-content">
        {projectSelected
          ? <CSSTransitionGroup
              component="div"
              className="project-background-wrapper"
              transitionName="projectBackground"
              transitionEnter={true}
              transitionEnterTimeout={600}
              transitionLeave={true}
              transitionLeaveTimeout={600}
              transitionAppear={true}
              transitionAppearTimeout={600}
            >
              <div
                id="project-background"
                style={backgroundImage}
                key={projectSelected.background}
              />
            </CSSTransitionGroup>
          : <div id="project-background" />}
        <div id="background-filter" />

        {isMobile() && <HeaderButtons noBack={noBack} noMenu={noMenu} />}

        <BasePage>
          {this.props.children}
        </BasePage>

        {!isMobile() &&
          <ProjectListContainer projectSelected={projectSelected} />}
      </div>
    );
  }
}

LoadedContent.propTypes = {
  children: PropTypes.object,
  projectSelected: PropTypes.object,
  noBack: PropTypes.bool,
  noMenu: PropTypes.bool
};

export default LoadedContent;



// WEBPACK FOOTER //
// ./src/components/LoadedContent.js